function setEdipart(state, edipart) {
	state.edipart = edipart;
}


function pushInboundEdiSetup(state, inboundEdiSetup) {
	state.edipart.inboundSetups.push(inboundEdiSetup);
}

function updateInboundEdiSetting(state, inboundEdiSetup) {
	let index = state.edipart.inboundSetups.findIndex(x => x.id === inboundEdiSetup.id);
	let newInboundSetups = state.edipart.inboundSetups.slice();
	newInboundSetups[index] = inboundEdiSetup;
	state.edipart.inboundSetups = newInboundSetups;
}

function updateOutboundEdiSetting(state, outboundEdiSetup) {
	let index = state.edipart.outboundSetups.findIndex(x => x.id === outboundEdiSetup.id);
	let newOutboundSetups = state.edipart.outboundSetups.slice();
	newOutboundSetups[index] = outboundEdiSetup;
	state.edipart.outboundSetups = newOutboundSetups;
}

function pushOutboundEdiSetup(state, outboundEdiSetup) {
	state.edipart.outboundSetups.push(outboundEdiSetup);
}

function deleteInboundSetup(state, edipart) {
	state.edipart = edipart;
}

function deleteOutboundSetup(state, outboundSetup) {
	let index = state.edipart.outboundSetups.findIndex(x => x.id === outboundSetup.id);
	state.edipart.outboundSetups.splice(index, 1);
}
export default { setEdipart, pushInboundEdiSetup, pushOutboundEdiSetup, deleteInboundSetup, deleteOutboundSetup, updateInboundEdiSetting, updateOutboundEdiSetting };